/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Header, Loading } from 'components';
import { Button } from 'react-bootstrap';
import { axius, types, images } from 'utils';
import { _store, _update } from '_Store';
import { useIonRouter } from '@ionic/react';

interface Params {
	id: string;
}
interface Props extends RouteComponentProps, types.StateProps {}
const Webhook: React.FC<Props> = (props) => {
	const {
		__data: { cartDefault },
	} = _store.useState();

	const router = useIonRouter();

	const path = props.history.location.pathname.split('/')[2]?.split('.') || {};
	const params: Params = { id: path[0] };

	const [data, setData] = React.useState<{ order: any; payment: any }>({
		order: {},
		payment: {},
	});
	const [loading, setLoading] = React.useState(true);

	React.useEffect(() => {
		setLoading(true);
		const timer = setInterval(() => {
			Promise.all([
				axius.get(`orders/${params.id}`),
				axius.get(`payments/${params.id}`),
			]).then(
				([orderRes, payRes]: [types.AxiusResponse, types.AxiusResponse]) => {
					if (orderRes && orderRes.data?.id && payRes && payRes.data?.id) {
						if (payRes?.data?.status === types.PaymentStatuses.COMPLETED) {
							_update.data('cart', cartDefault);
							_update.data('deliveryFees', []);
						}
						setData({ order: orderRes.data, payment: payRes.data });
						setLoading(false);
						clearInterval(timer);
					}
				}
			);
		}, 10 * 1000);
		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<React.Fragment>
			{loading && <Loading text="confirming payment, please wait..." />}

			{!loading && (
				<div>
					<Header {...props} showSearch={true} showSegments={false} />

					<div className="p-3 content c-mediums text-center">
						<p>&nbsp;</p>
						{data.payment.status === types.PaymentStatuses.COMPLETED && (
							<>
								<img src={images.PaySuccess} alt="PaySuccess" />
								<h5 className="fw-600 mt-4">Payment Successful!</h5>
								<div className="text-muted">
									Your payment was successful and your order <br /> has been
									sent for confirmation! <br />
									You can track your order in the app
								</div>
							</>
						)}
						{data.payment.status === types.PaymentStatuses.FAILED && (
							<>
								<img src={images.PayFailed} alt="PayFailed" />
								<h5 className="fw-600 mt-4">Oh no, your payment failed</h5>
								<div className="text-muted">
									Your transaction didn't go through. <br />
									Please try again.
								</div>
							</>
						)}

						<p>&nbsp;</p>
						<p>&nbsp;</p>

						{data.payment.status === types.PaymentStatuses.COMPLETED && (
							<Button
								variant="secondary btn-block btn-lg"
								onClick={() => router.push(`/orders/${data.order.id}`)}
							>
								Track Order
							</Button>
						)}

						{data.payment.status === types.PaymentStatuses.FAILED && (
							<Button
								variant="secondary btn-block btn-lg"
								onClick={() => router.push(`/cart`)}
							>
								Retry
							</Button>
						)}

						<div className="text-center my-4">
							<span
								className="primary fw-600 ins"
								onClick={() => router.push(`/`)}
							>
								Continue Shopping
							</span>
						</div>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default Webhook;
